module.exports = __webpack_public_path__ + "img/GR.dbbfefe6.svg";